import { ApiError, apiFetch } from '@/shared/api/apiFetch';
import { isSessionValidForClient } from '@/entities/auth/lib/isSessionValidForClient';
import { SessionSchema, Session } from '../model/sessionSchema';
import { CurrentUserSchema, User } from '../model/authSchema';

export async function createSession(login: string, password: string): Promise<Session> {
  const json = await apiFetch<unknown>('/sessions', {
    method: 'POST',
    body: { login, password },
  });
  const parsed = SessionSchema.parse(json);
  return parsed;
}

export async function fetchCurrentSession(): Promise<Session | null> {
  try {
    const json = await apiFetch<unknown>('/sessions/current', { method: 'GET' });
    const session = SessionSchema.parse(json);
    if (!isSessionValidForClient(session)) return null;
    return session;
  } catch (e) {
    if (e instanceof ApiError && e.status === 401) return null;
    throw e;
  }
}

export async function deleteCurrentSession(): Promise<void> {
  await apiFetch('/sessions/current', { method: 'DELETE' });
}

export async function fetchCurrentUser(): Promise<User> {
  const json = await apiFetch<unknown>('/users/me', { method: 'GET', cache: 'no-store' });
  const parsed = CurrentUserSchema.parse(json);
  return parsed.user;
}

export async function loadAuthSession(): Promise<{ session: Session; user: User } | null> {
  const session = await fetchCurrentSession();
  if (!session) return null;
  const user = await fetchCurrentUser();
  return { session, user };
}
